import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        redirect: '/map'
    },
    {
        path: '/manager',
        name: 'Manager',
        component: () => import('../views/Manager.vue'),
        redirect: '/manager/home',  // 重定向到主页
        children: [
            { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
            {
                path: 'home',
                name: 'Home',
                meta: { name: '系统首页', permission: ['ADMIN'] },
                component: () => import('../views/manager/Home')
            },
            {
                path: 'orders',
                name: 'Orders',
                meta: { name: '课程订单' },
                component: () => import('../views/manager/order/Orders')
            },
            {
                path: 'salaryForAdmin',
                name: 'SalaryForAdmin',
                meta: { name: '推广收入' },
                component: () => import('../views/manager/order/SalaryForAdmin')
            },
            {
                path: 'totalSalary',
                name: 'TotalSalary',
                meta: { name: '营收总览' },
                component: () => import('../views/manager/order/TotalSalary')
            },


            {
                path: 'settingPrice',
                name: 'SettingPrice',
                meta: { name: '上架设置' },
                component: () => import('../views/manager/order/SettingPrice')
            },



            { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
            { path: 'role', name: 'Role', meta: { name: '权限设置' }, component: () => import('../views/manager/Role/Role') },
            {
                path: 'apply',
                name: 'Apply',
                meta: { name: '模拟申请' },
                component: () => import('../views/manager/Role/Apply.vue')
            },
            {
                path: 'adminPerson',
                name: 'AdminPerson',
                meta: { name: '个人信息' },
                component: () => import('../views/manager/AdminPerson')
            },
            {
                path: 'partnerRole',
                name: 'PartnerRole',
                meta: { name: '考试资料' },
                component: () => import('../views/manager/BaseMessage/PartnerRole')
            },
            {
                path: 'major',
                name: 'Major',
                meta: { name: '专业方向' },
                component: () => import('../views/manager/BaseMessage/MajorToward')
            },
            {
                path: 'majorDetail',
                name: 'majorDetail',
                meta: { name: '专业信息' },
                component: () => import('../views/manager/BaseMessage/MajorDetail')
            },
            {
                path: 'school',
                name: 'School',
                meta: { name: '学校信息' },
                component: () => import('../views/manager/BaseMessage/SchoolMessage')
            },
            {
                path: 'password',
                name: 'Password',
                meta: { name: '修改密码' },
                component: () => import('../views/manager/Password')
            },
            { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },

            {
                path: 'bookIndex',
                name: 'BookIndex',
                meta: { name: '书籍编辑' },
                component: () => import('../views/manager/MemoryCard/BookIndex')
            },
            {
                path: 'cardIndex',
                name: 'CardIndex',
                meta: { name: '卡片制作(批量)' },
                component: () => import('../views/manager/MemoryCard/CardIndex')
            },
            {
                path: 'CardReview',
                name: 'CardReview',
                meta: { name: '卡片预览(制卡)' },
                component: () => import('../views/manager/MemoryCard/CardReview')
            }, {
                path: 'chapterAudio',
                name: 'ChapterAudio',
                meta: { name: '章节音频制作' },
                component: () => import('../views/manager/Audio/ChapterAudio')
            }, {
                path: 'cardAudio',
                name: 'CardAudio',
                meta: { name: '卡片音频制作' },
                component: () => import('../views/manager/Audio/CardAudio')
            }, {
                path: 'drawImage',
                name: 'drawImage',
                meta: { name: '小工具' },
                component: () => import('../views/manager/Uitil/DrawImage')
            }, {
                path: 'aiGenerated',
                name: 'aiGenerated',
                meta: { name: 'AI生成' },
                component: () => import('../views/manager/Uitil/AiGenerated')
            }, {
                path: 'AiGeneratedFormulaToWords',
                name: 'AiGeneratedFormulaToWords',
                meta: { name: 'AI生成' },
                component: () => import('../views/manager/Uitil/AiGeneratedFormulaToWords')
            },

            {
                path: 'AiGeneratedManage',
                name: 'AiGeneratedManage',
                meta: { name: 'AI管理后台' },
                component: () => import('../views/manager/Uitil/AiGeneratedManage')
            },




            {
                path: 'commonBookIndex',
                name: 'CommonBookIndex',
                meta: { name: '书籍编辑' },
                component: () => import('../views/manager/Common/BookIndex')
            },
            {
                path: 'commonCardIndex',
                name: 'CommonCardIndex',
                meta: { name: '卡片制作(批量)' },
                component: () => import('../views/manager/Common/CardIndex')
            },
            {
                path: 'commonCardReview',
                name: 'CommonCardReview',
                meta: { name: '卡片预览(制卡)' },
                component: () => import('../views/manager/Common/CardReview')
            },
        ]
    },
    {
        path: '/map',
        name: 'Map',
        component: () => import('../views/MapView.vue'),
    },
    {
        path: '/courseDetails',
        name: 'CourseDetails',
        meta: { name: '全部课程' },
        component: () => import('../views/CourseDetails.vue')
    },

    { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
    { path: '/admin-login', name: 'AdminLogin', meta: { name: '管理员登录' }, component: () => import('../views/Login.vue') },
    { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
    { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})


// 注：不需要前台的项目，可以注释掉该路由守卫
// 路由守卫
router.beforeEach((to, from, next) => {
    let user = {}

    try {
        user = JSON.parse(localStorage.getItem('xm-user') || '{}')
    } catch (error) {
        localStorage.removeItem('xm-user')
        return next('/')
    }

    const isManagerRoute =
        to.path === '/manager' ||
        to.path.startsWith('/manager/')

    if (!isManagerRoute) {
        return next()
    }

    if (!user.role || !user.token || !user.uid) {
        localStorage.removeItem('xm-user')
        return next('/admin-login')
    }

    // 页面跳转只做本地菜单权限判断，接口安全由后端 JWT 拦截器兜底。
    const requiredPermission = to.meta.permission

    if (
        Array.isArray(requiredPermission) &&
        requiredPermission.length > 0 &&
        !requiredPermission.includes(user.role)
    ) {
        if (to.path !== '/manager/403') {
            return next('/manager/403')
        }
    }

    if (to.path === '/manager') {
        return next('/manager/home')
    }

    return next()
})

export default router
